export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_FILTER_OPTIONS = 'SET_FILTER_OPTIONS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_LOCATION_TREE = 'SET_LOCATION_TREE'
export const SET_LOCATIONS = 'SET_LOCATIONS'
export const SET_LOCATION = 'SET_LOCATION'
export const SET_LOCATIONS_FOUND = 'SET_LOCATIONS_FOUND'
export const SET_PREFERENCES = 'SET_PREFERENCES'
export const UPDATE_PREFERENCE = 'UPDATE_PREFERENCE'
export const RESET_PREFERENCE_CHANGE = 'RESET_PREFERENCE_CHANGE'

export const LOCATIONS_SEARCH_TERM = 'LOCATIONS_SEARCH_TERM'
export const LOCATIONS_PAGE_SIZE = 'LOCATIONS_PAGE_SIZE'
export const LOCATIONS_SORT_DIR = 'LOCATIONS_SORT_DIR'
export const LOCATIONS_ORDER_BY = 'LOCATIONS_ORDER_BY'
export const LOCATIONS_FILTER_BY = 'LOCATIONS_FILTER_BY'



// WEBPACK FOOTER //
// ./src/store/modules/locations/types.js